// Fleet Tracker is a separate app (apps/fleet-tracker-frontend) with its own
// hostname per environment, so the portal has to pick the right one at runtime.
// Hostnames come from infra/kubernetes/overlays/{prod,dev}/fleet-tracker/httproute.yaml.
export namespace LibFleetTracker {
  const PROD_URL = "https://fleet-tracker.froygruppen.no";
  const DEV_URL = "https://fleet-tracker.dev.froygruppen.no";

  // Everything that is not the production portal (staging, demo, pr-* previews,
  // local dev) points at the staging Fleet Tracker — there is no per-preview or
  // local instance to link to.
  export function urlForHostname(hostname: string): string {
    if (hostname === "localhost" || hostname === "127.0.0.1") return DEV_URL;
    if (hostname.endsWith(".dev.froygruppen.no")) return DEV_URL;
    return PROD_URL;
  }

  export function url(): string {
    return urlForHostname(window.location.hostname);
  }
}
